import { render, staticRenderFns } from "./consumeRecord.vue?vue&type=template&id=c80a8004&scoped=true&"
import script from "./consumeRecord.vue?vue&type=script&lang=js&"
export * from "./consumeRecord.vue?vue&type=script&lang=js&"
import style0 from "./consumeRecord.vue?vue&type=style&index=0&id=c80a8004&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80a8004",
  null
  
)

export default component.exports